import { Dayjs } from 'dayjs'
import { RangeValueType } from 'rc-picker/lib/PickerInput/RangePicker'

export const isLessThanOneYear = (dates: RangeValueType<Dayjs>) => {
  if (dates && dates[0] && dates[1]) {
    return dates[1].diff(dates[0], 'year', true) < 1
  }
  return false
}
